export default __webpack_public_path__ + "static/media/01.61df1ef0.svg";